// Main
const API_URL = process.env.REACT_APP_BASEURL

// SUBSCRIPTION_REPORT 
const SUBSCRIPTION_REPORT = {
    LISTING: '[ADMIN] LISTING',
    SEARCH: '[ADMIN] SEARCH',
    ERROR: '[ADMIN] ERROR'
}

export { API_URL, SUBSCRIPTION_REPORT }